export function arrayBufferToString(str) {
  let byteArray = new Uint8Array(str);
  let byteString = "";
  for (let i = 0; i < byteArray.byteLength; i++) {
    byteString += String.fromCodePoint(byteArray[i]);
  }
  return byteString;
}
